export const MAIN_CLASS_NAME = 'ib-number-input';
